import { LoadingLifecycle, RejectedError } from './types';

export type SetRejected = <T>(error: RejectedError) => LoadingLifecycle<T>;
export const setRejected: SetRejected = (error) => ({
  pending: false,
  fulfilled: undefined,
  rejected: error,
});
